/**
 * botTargetPriority — in-range AA pick: champion > minion > structure; lowest HP among champs (FID-BOT-13 / FID-BOT-15).
 *
 * Pure JS — no Three.js, no DOM.
 */

const STRUCTURE_TYPES = new Set(['turret', 'inhibitor', 'nexus', 'inhibitorTurret']);

function entityZ(e) {
  if (!e) return 0;
  if (e.z !== undefined) return e.z;
  return e.y !== undefined ? e.y : 0;
}

function distance2d(a, b) {
  return Math.hypot(b.x - a.x, entityZ(b) - entityZ(a));
}

export function enemyKindRank(entity) {
  const t = String(entity?.type || '');
  if (t === 'champion') return 0;
  if (entity?.minionType || t.startsWith('minion')) return 1;
  if (STRUCTURE_TYPES.has(t)) return 2;
  return 3;
}

function hpRatio(entity) {
  const maxHp = Number(entity?.maxHp) || 1;
  const hp = Number(entity?.hp);
  if (!Number.isFinite(hp)) return 1;
  return hp / maxHp;
}

export function pickInRangeAttackTarget(bot, enemies = [], attackRange = 0) {
  if (!bot || !(attackRange > 0)) return null;
  let best = null;
  let bestRank = Infinity;
  let bestRatio = Infinity;
  let bestDist = Infinity;
  for (const enemy of enemies) {
    if (!enemy || enemy.isDead) continue;
    const dist = distance2d(bot, enemy);
    if (dist > attackRange) continue;
    const rank = enemyKindRank(enemy);
    const ratio = hpRatio(enemy);
    const betterRank = rank < bestRank;
    const betterHp = rank === bestRank && ratio < bestRatio;
    const betterDist = rank === bestRank && ratio === bestRatio && dist < bestDist;
    if (betterRank || betterHp || betterDist) {
      best = enemy;
      bestRank = rank;
      bestRatio = ratio;
      bestDist = dist;
    }
  }
  return best;
}
